window.PhoneOtpVerificationForm = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            textBox:{
                inputVerificationCode:'#phone-otp-verify-verification-code',
                otpModelId:'#otp-modelId',
                updatedPopupModelId:'#updated-popup-modelId',
                newPhoneNumber :'#new-phone-number-text-input'
            },
            link:{
                sentPhoneOtp:'#phone-otp-verify-send-otp'
            },
            button: {
                triggerConfirm: '#phone-otp-verify-trigger-verify',
                phoneNumberUpdated:'#phone-number-otp-confirmed'
            }
        },
        urls: {
            sendOtpToPhoneUrl:'/api/sitecore/UpdateMemberZonePhoneNumber/TriggerOtpToPhone',
            verifyOtpUrl:'/api/sitecore/UpdateMemberZonePhoneNumber/VerifyOtp',
            confirmOtp:'/api/sitecore/UpdateMemberZonePhoneNumber/ConfirmOtp',
            phoneOtpVerificationPageUrl : '/my-account/details/phone/update-memberzone-phone-number/phone-number-otp-verification',
            personalDetailsPageUrl: '/my-account/details',
            errorPageUrl: '/error/error-page'
        },
        statusDescription: {
            accepted: 'accepted',
            successful: 'ok'
        },
        constants: {
            codeUnitSeparator: 31,
            codeLowerLimit: 48,
            codeUpperLimit: 57,
            Length: 4,
            AccountAttribute: 'AccountMobile',
            NumbersOnlyRegex: /[^0-9]/g
        },
        func: {
            init: function () {
                self.func.bindings();
            },
            bindings: function () {
                $(self.elements.link.sentPhoneOtp).on('click', self.func.sentOtpToPhone);
                $(self.elements.textBox.inputVerificationCode).on('keypress', self.func.inputGuardNumbersOnly);
                $(self.elements.textBox.inputVerificationCode).on('paste', self.func.inputGuardPasteNumbers);
                $(self.elements.button.triggerConfirm).on('click',self.func.confirmOtp);
                $(self.elements.button.phoneNumberUpdated).on('click', self.func.phoneNumberUpdated);
            },
            phoneNumberUpdated: function (){
                window.location.href = self.urls.personalDetailsPageUrl;
            },
            sentOtpToPhone: function (event) {
                event.preventDefault();
                $.ajax({
                    type: 'PATCH',
                    url: self.urls.sendOtpToPhoneUrl,
                    success: function(response) {
                        if(response.statusCode?.toLowerCase() === self.statusDescription.accepted) {
                            const modelId = $(self.elements.textBox.otpModelId).val().trim();
                            window.openModal(modelId);
                        }
                    },
                    error: function() {
                        window.location.href = self.urls.errorPageUrl;
                    }
                });
            },
            confirmOtp: function (event) {
                event.preventDefault();
                const details = {
                    Code: $(self.elements.textBox.inputVerificationCode).val().trim(),
                    AccountAttribute: self.constants.AccountAttribute
                };
                $.ajax({
                    type: 'POST',
                    url: self.urls.confirmOtp,
                    data: details,
                    success: function(response) {
                        if(response?.serviceResponse?.statusCode?.toLowerCase() === self.statusDescription.successful) {
                            const popupId = $(self.elements.textBox.updatedPopupModelId).val().trim();
                            $(self.elements.textBox.newPhoneNumber).val(response?.mzNewPhoneNumber);
                            window.openModal(popupId);
                        }
                    },
                    error: function() {
                        window.location.href = self.urls.errorPageUrl;
                    }
                });
            },
            inputGuardNumbersOnly: function (e) {
                const code = e.charCode || e.keyCode;
                const isValidCode = code <= self.constants.codeUnitSeparator;
                const isValidNumericCode = code >= self.constants.codeLowerLimit &&
                    code <= self.constants.codeUpperLimit;
                if (!isValidCode && !isValidNumericCode) {
                    e.preventDefault();
                    return false;
                }
            },
            inputGuardPasteNumbers: function (e) {
                e.preventDefault();
                let copiedData = e.originalEvent.clipboardData.getData('text');
                if (copiedData) {
                    e.target.value = copiedData.replace(self.constants.NumbersOnlyRegex, '').slice(0, self.constants.Length);
                }
            },
        }
    };

    return {
        Init: self.func.init
    };
}) ();

$(document).ready(function () {
    if ('phone-otp-verify-form' === $('#phone-otp-verify-form').data('feature')) {
        window.PhoneOtpVerificationForm.Init();
    }
});
